var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          on: {
            click: function($event) {
              return _vm.toggleModal("modalReject" + _vm.id)
            }
          }
        },
        [_vm._v("Reject")]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modalReject" + _vm.id,
          attrs: {
            heading: "Rejection of Reactivate Account",
            "times-button": _vm.timesButton,
            "static-backdrop": _vm.staticBackdrop
          }
        },
        [
          _c("div", [
            _c("form", { attrs: { method: "POST" } }, [
              _c("input", {
                attrs: { type: "hidden", name: "_csrfToken" },
                domProps: { value: _vm.csrfToken }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "id" },
                domProps: { value: _vm.id }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "reason" },
                domProps: { value: _vm.reason }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "small-12 text-left" }, [
                _c("div", [_vm._v("Select a reason.")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reason,
                          expression: "reason"
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.reason = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("Select a reason")
                      ]),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value:
                              "Personal info does not match (Details provided do not align with records)."
                          }
                        },
                        [
                          _vm._v(
                            "Personal info does not match (Details provided do not align with records)."
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value:
                              "Incorrect or missing ID uploaded (Other documents uploaded instead of an official ID)."
                          }
                        },
                        [
                          _vm._v(
                            "Incorrect or missing ID uploaded (Other documents uploaded instead of an official ID)."
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    staticClass: "button mt-3",
                    attrs: {
                      disabled: _vm.reason === "",
                      type: "submit",
                      value: "Submit"
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.errors.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.errors, function(error) {
                        return _c(
                          "div",
                          { key: error, staticClass: "text-danger" },
                          [_c("small", [_vm._v(" " + _vm._s(error))])]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503b7662", { render: render, staticRenderFns: staticRenderFns })
  }
}